<template>
    <div v-if="marriageFavorableInfoData && marriageFavorableInfoData.infoOne" class="marriage-result-energy text-center" :class="'bg-'+marriageFavorableInfoData.infoOne.gender">
        <div class="marriage-energy-avatar-box" :class="'avatar-'+marriageFavorableInfoData.infoOne.gender">
            <div class="avatar-content clearfix">
                <div class="marriage-energy-avatar" :class="'avatar-'+marriageFavorableInfoData.infoOne.gender"></div>
                <span class="marriage-energy-nickname">{{ marriageFavorableInfoData.infoOne.name }}</span>
            </div>
        </div>
        <div class="marriage-energy-fate"><span :class="'wd-'+marriageFavorableInfoData.infoOne.bz.wxEn">{{ marriageFavorableInfoData.infoOne.bz.text }}</span>命</div>
        <div class="marriage-energy-sub-text">注意民间有用年柱纳音来测算是什么命的，以年来论命不严谨，一年出生的人那可太多了。</div>
        <div class="marriage-energy-content">
            <div class="marriage-energy-title"><span>生日能量强弱</span></div>
            <div class="marriage-energy-strong">{{ marriageFavorableInfoData.infoOne.strong ? '身强' : '身弱' }}</div>
            <div class="marriage-energy-sub-text">身强身弱并无绝对好坏，都有典型成功人士。身强的人精力更旺盛，抗击打能力更强。</div>
        </div>
        <div class="marriage-energy-content">
            <div class="marriage-energy-title"><span>生日五行能量大小分布</span></div>
            <div class="marriage-energy-bar">
                <div class="energy-bar-item marriage-energy-bar-item item-gold">
                    <div class="energy-bar-text">金</div>
                    <div class="energy-bar-box">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoOne.gold.value+'%;'"></span></div>
                    </div>
                    <div class="energy-bar-num">{{ marriageFavorableInfoData.infoOne.gold.value + '%' }}</div>
                </div>
                <div class="energy-bar-item marriage-energy-bar-item item-wood">
                    <div class="energy-bar-text">木</div>
                    <div class="energy-bar-box">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoOne.wood.value+'%;'"></span></div>
                    </div>
                    <div class="energy-bar-num">{{ marriageFavorableInfoData.infoOne.wood.value + '%' }}</div>
                </div>
                <div class="energy-bar-item marriage-energy-bar-item item-water">
                    <div class="energy-bar-text">水</div>
                    <div class="energy-bar-box">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoOne.water.value+'%;'"></span></div>
                    </div>
                    <div class="energy-bar-num">{{ marriageFavorableInfoData.infoOne.water.value + '%' }}</div>
                </div>
                <div class="energy-bar-item marriage-energy-bar-item item-fire">
                    <div class="energy-bar-text">火</div>
                    <div class="energy-bar-box">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoOne.fire.value+'%;'"></span></div>
                    </div>
                    <div class="energy-bar-num">{{ marriageFavorableInfoData.infoOne.fire.value + '%' }}</div>
                </div>
                <div class="energy-bar-item marriage-energy-bar-item item-soil">
                    <div class="energy-bar-text">土</div>
                    <div class="energy-bar-box">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoOne.soil.value+'%;'"></span></div>
                    </div>
                    <div class="energy-bar-num">{{ marriageFavorableInfoData.infoOne.soil.value + '%' }}</div>
                </div>
            </div>
        </div>
        <div class="marriage-energy-content">
            <div class="marriage-energy-title"><span>生日五行喜忌</span></div>
            <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>五行喜忌</span><span class="arrow-right"></span></div>
            <div class="marriage-energy-p">喜<span :class="'wdd-'+gWx.wxEn" v-for="gWx in marriageFavorableInfoData.infoOne.goodWx" :key="gWx+Math.random(0,10)">{{ gWx.wxText }}</span>，忌<span :class="'wdd-'+gWx.wxEn" v-for="gWx in marriageFavorableInfoData.infoOne.badWx"  :key="gWx+Math.random(0,10)">{{ gWx.wxText }}</span></div>
            <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>喜用颜色</span><span class="arrow-right"></span></div>
            <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoOne.goodColour.join('、') }}</div>
            <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>忌用颜色</span><span class="arrow-right"></span></div>
            <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoOne.badColour.join('、') }}</div>
            <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>喜用生肖</span><span class="arrow-right"></span></div>
            <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoOne.goodAni.join('、') }}</div>
            <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>易冲生肖</span><span class="arrow-right"></span></div>
            <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoOne.badAni.join('、') }}</div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
export default {
    name: 'MarriageReportOneResult',
    props: {
        resultType: {
            type: String,
            default() { return '' }
        },
    },
    components: {  },
    computed: {
        marriageFavorableInfoData() {
            return this.$store.state.marriage.marriageFavorableInfoData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
        }
    },
    methods: {
        
    }
}
</script>